/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Dashboard_viewer = {
    readonly user: {
        readonly username: string;
        readonly email: string | null;
        readonly userTourComplete: number | null;
        readonly cellphoneNumber: string | null;
        readonly regions: string | null;
        readonly isHub: boolean;
        readonly roles: ReadonlyArray<{
            readonly name: string;
        }>;
        readonly loginCount: {
            readonly lastLogin: string | null;
            readonly lastWeek: number;
            readonly lastMonth: number;
            readonly lastYear: number;
        } | null;
        readonly lastPrompt: {
            readonly id: string;
            readonly LastPromptTime: string | null;
        } | null;
    } | null;
    readonly report: {
        readonly contact: ReadonlyArray<{
            readonly cellNumber: string;
            readonly regionName: string | null;
            readonly contactName: string;
            readonly spoke: {
                readonly accountName: string;
            };
        }> | null;
        readonly detailedSalesReport: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"DashboardViewDataModal_report">;
        }> | null;
    } | null;
    readonly users: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly username: string;
                readonly regions: string | null;
                readonly cellphoneNumber: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"EntityCombobox_viewer" | "DashboardDataViewer_viewer">;
    readonly " $refType": "Dashboard_viewer";
};
export type Dashboard_viewer$data = Dashboard_viewer;
export type Dashboard_viewer$key = {
    readonly " $data"?: Dashboard_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Dashboard_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cellphoneNumber",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regions",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "entityReference",
    "variableName": "entityReference"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "entityReference"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Dashboard_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userTourComplete",
          "storageKey": null
        },
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isHub",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "roles",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LoginCount",
          "kind": "LinkedField",
          "name": "loginCount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastLogin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastWeek",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastYear",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LastPrompt",
          "kind": "LinkedField",
          "name": "lastPrompt",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "LastPromptTime",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Report",
      "kind": "LinkedField",
      "name": "report",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "ContactReport",
          "kind": "LinkedField",
          "name": "contact",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cellNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regionName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "contactName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Account",
              "kind": "LinkedField",
              "name": "spoke",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accountName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "DetailedSalesReport",
          "kind": "LinkedField",
          "name": "detailedSalesReport",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DashboardViewDataModal_report"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ViewerUsersConnection",
      "kind": "LinkedField",
      "name": "users",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ViewerUsersEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v2/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityCombobox_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardDataViewer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();
(node as any).hash = 'de22cebfc6f9e87db56bff040680f7c3';
export default node;
